"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactColor = require("react-color");

var _common = require("react-color/lib/components/common");

var _deepEqual = _interopRequireDefault(require("deep-equal"));

var _input = _interopRequireDefault(require("./input"));

var _withTheme = require("../../wrappers/with-theme");

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var id = -1;

var getInputId = function getInputId() {
  return "input-id-".concat(++id);
};

var Slider = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var _ref$small = _ref.small,
      small = _ref$small === void 0 ? false : _ref$small,
      _ref$large = _ref.large,
      large = _ref$large === void 0 ? false : _ref$large;
  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n        ".concat(small ? "h-3 mt-1 w-1" : large ? "h-9 mt-3 w-3" : "h-6 mt-2 w-2", "\n        rounded pointer-events-none ").concat(theme.accent3, "\n      "),
    style: {
      transform: "translate(-50%, -50%)"
    }
  });
});

var ColorPicker = function ColorPicker(_ref2) {
  var _ref2$showPreview = _ref2.showPreview,
      showPreview = _ref2$showPreview === void 0 ? true : _ref2$showPreview,
      _ref2$showInputs = _ref2.showInputs,
      showInputs = _ref2$showInputs === void 0 ? true : _ref2$showInputs,
      _ref2$showLabels = _ref2.showLabels,
      showLabels = _ref2$showLabels === void 0 ? true : _ref2$showLabels,
      _ref2$showHex = _ref2.showHex,
      showHex = _ref2$showHex === void 0 ? true : _ref2$showHex,
      _ref2$showRgb = _ref2.showRgb,
      showRgb = _ref2$showRgb === void 0 ? true : _ref2$showRgb,
      _ref2$small = _ref2.small,
      small = _ref2$small === void 0 ? false : _ref2$small,
      _ref2$large = _ref2.large,
      large = _ref2$large === void 0 ? false : _ref2$large,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$autoFocus = _ref2.autoFocus,
      autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus,
      props = _objectWithoutProperties(_ref2, ["showPreview", "showInputs", "showLabels", "showHex", "showRgb", "small", "large", "disabled", "autoFocus"]);

  var _React$useState = _react["default"].useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      node = _React$useState2[0],
      setNode = _React$useState2[1],
      hexId = _react["default"].useRef(getInputId()),
      rgbId = _react["default"].useRef(getInputId());

  _react["default"].useEffect(function () {
    node && autoFocus && node.focus();
  }, [node, autoFocus]);

  var theme = (0, _withTheme.useTheme)(),
      inputTheme = theme["input".concat((0, _utils.composeOptions)({
    large: large,
    small: small
  }))];
  return /*#__PURE__*/_react["default"].createElement("div", {
    tabIndex: disabled ? -1 : 0,
    ref: setNode,
    className: "\n        ".concat(inputTheme, " w-full h-full\n      ")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n          grid\n          ".concat(small ? "gap-y-1 py-1" : large ? "gap-y-4 py-2" : "gap-y-2 py-1", "\n        "),
    style: {
      gridTemplateRows: "auto auto".concat(showInputs ? " auto" : "")
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n            grid grid-cols-12\n            ".concat(small ? "gap-x-1" : large ? "gap-x-4" : "gap-x-2", "\n          "),
    style: {
      height: large ? "20rem" : small ? "10rem" : "15rem"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n              relative h-full cursor-pointer\n              col-span-".concat(showPreview ? "9" : "12", "\n            ")
  }, /*#__PURE__*/_react["default"].createElement(_common.Saturation, _extends({}, props, {
    style: {
      pointer: {
        "pointerEvents": "none"
      }
    }
  }))), !showPreview ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-3 h-full rounded",
    style: {
      backgroundColor: props.hex
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n            rounded cursor-pointer relative\n            ".concat(small ? "h-2" : large ? "h-6" : "h-4", "\n          ")
  }, /*#__PURE__*/_react["default"].createElement(_common.Hue, _extends({}, props, {
    direction: "horizontal",
    pointer: function pointer() {
      return /*#__PURE__*/_react["default"].createElement(Slider, {
        small: small,
        large: large
      });
    }
  }))), !showInputs ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n              grid grid-cols-".concat(Boolean(showHex) + Boolean(showRgb), "\n              ").concat(small ? "gap-x-1" : large ? "gap-x-4" : "gap-x-2", "\n            ")
  }, !showHex ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: !showLabels ? null : "".concat(theme.accent1, " rounded\n                  ").concat(!showLabels ? "" : small ? "px-1 pt-1 pb-0" : large ? "px-4 pt-4 pb-3" : "px-2 pt-2 pb-1", "\n                ")
  }, /*#__PURE__*/_react["default"].createElement(HexInput, _extends({
    id: hexId.current
  }, props, {
    value: props.hex,
    small: small,
    large: large,
    showLabels: showLabels
  }))), !showRgb ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: !showLabels ? null : "".concat(theme.accent1, " rounded\n                  ").concat(!showLabels ? "" : small ? "px-1 pt-1 pb-0" : large ? "px-4 pt-4 pb-3" : "px-2 pt-2 pb-1", "\n                ")
  }, /*#__PURE__*/_react["default"].createElement(RgbInput, _extends({
    id: rgbId.current
  }, props, {
    value: props.rgb,
    small: small,
    large: large,
    showLabels: showLabels
  }))))));
};

var WrappedColorPicker = (0, _reactColor.CustomPicker)(ColorPicker);

var ColorInput = function ColorInput(_ref3) {
  var value = _ref3.value,
      onChange = _ref3.onChange,
      props = _objectWithoutProperties(_ref3, ["value", "onChange"]);

  var handleChange = _react["default"].useCallback(function (_ref4) {
    var hex = _ref4.hex;
    onChange(hex);
  }, [onChange]);

  return /*#__PURE__*/_react["default"].createElement(WrappedColorPicker, _extends({
    color: value || ""
  }, props, {
    onChange: handleChange
  }));
};

var _default = ColorInput;
exports["default"] = _default;

var createHexInitialState = function createHexInitialState(value) {
  return {
    value: value.toUpperCase(),
    blurValue: value.toUpperCase()
  };
};

var HexReducer = function HexReducer(state, action) {
  var type = action.type,
      payload = _objectWithoutProperties(action, ["type"]);

  switch (type) {
    case "update-state":
      return _objectSpread(_objectSpread({}, state), payload);

    default:
      return state;
  }
};

var TextInput = /*#__PURE__*/_react["default"].forwardRef(function (_ref5, ref) {
  var id = _ref5.id,
      label = _ref5.label,
      showLabels = _ref5.showLabels,
      props = _objectWithoutProperties(_ref5, ["id", "label", "showLabels"]);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col items-center"
  }, /*#__PURE__*/_react["default"].createElement(_input["default"], _extends({
    id: id,
    ref: ref
  }, props)), !showLabels ? null : /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id,
    className: "\n            font-bold\n            ".concat(props.small ? "text-sm" : props.large ? "text-lg" : "text-base", "\n          ")
  }, label));
});

var HexInput = function HexInput(_ref6) {
  var id = _ref6.id,
      value = _ref6.value,
      onChange = _ref6.onChange,
      _ref6$small = _ref6.small,
      small = _ref6$small === void 0 ? false : _ref6$small,
      _ref6$large = _ref6.large,
      large = _ref6$large === void 0 ? false : _ref6$large,
      _ref6$showLabels = _ref6.showLabels,
      showLabels = _ref6$showLabels === void 0 ? true : _ref6$showLabels;

  var _React$useReducer = _react["default"].useReducer(HexReducer, value, createHexInitialState),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1],
      input = _react["default"].useRef(null),
      prevState = _react["default"].useRef(null),
      prevValue = _react["default"].useRef(null);

  _react["default"].useEffect(function () {
    if (value !== state.value && (prevValue.current !== value || prevState.current !== state.value)) {
      if (input.current === document.activeElement) {
        dispatch({
          type: "update-state",
          blurValue: value.toUpperCase()
        });
      } else {
        dispatch({
          type: "update-state",
          value: value.toUpperCase(),
          blurValue: !state.blurValue && value.toUpperCase()
        });
      }
    }

    prevState.current = state.value;
    prevValue.current = value;
  }, [value, state]);

  var handlechange = _react["default"].useCallback(function (value) {
    dispatch({
      type: "update-state",
      value: value
    });
    onChange(value);
  }, [onChange]);

  var handleBlur = _react["default"].useCallback(function (e) {
    if (state.blurValue) {
      dispatch({
        type: "update-state",
        value: state.blurValue,
        blurValue: null
      });
    }
  }, [state]);

  return /*#__PURE__*/_react["default"].createElement(TextInput, {
    type: "text",
    id: id,
    small: small,
    large: large,
    ref: input,
    onChange: handlechange,
    value: state.value,
    onBlur: handleBlur,
    showLabels: showLabels,
    label: "Hex"
  });
};

var createRgbInitialState = function createRgbInitialState(value) {
  return {
    value: value,
    blurValue: value
  };
};

var RgbReducer = function RgbReducer(state, action) {
  var type = action.type,
      payload = _objectWithoutProperties(action, ["type"]);

  switch (type) {
    case "update-state":
      return _objectSpread(_objectSpread({}, state), payload);

    case "update-value":
      return _objectSpread(_objectSpread({}, state), {}, {
        value: _objectSpread(_objectSpread({}, state.value), payload)
      });

    default:
      return state;
  }
};

var RgbInput = function RgbInput(_ref7) {
  var id = _ref7.id,
      value = _ref7.value,
      onChange = _ref7.onChange,
      _ref7$small = _ref7.small,
      small = _ref7$small === void 0 ? false : _ref7$small,
      _ref7$large = _ref7.large,
      large = _ref7$large === void 0 ? false : _ref7$large,
      _ref7$showLabels = _ref7.showLabels,
      showLabels = _ref7$showLabels === void 0 ? true : _ref7$showLabels;

  var _React$useReducer3 = _react["default"].useReducer(RgbReducer, value, createRgbInitialState),
      _React$useReducer4 = _slicedToArray(_React$useReducer3, 2),
      state = _React$useReducer4[0],
      dispatch = _React$useReducer4[1],
      rInput = _react["default"].useRef(null),
      gInput = _react["default"].useRef(null),
      bInput = _react["default"].useRef(null),
      prevState = _react["default"].useRef(null),
      prevValue = _react["default"].useRef(null);

  _react["default"].useEffect(function () {
    if (!(0, _deepEqual["default"])(value, state.value) && (!(0, _deepEqual["default"])(prevValue.current, value) || !(0, _deepEqual["default"])(prevState.current, state.value))) {
      var inputs = [rInput.current, gInput.current, bInput.current];

      if (inputs.includes(document.activeElement)) {
        dispatch({
          type: "update-state",
          blurValue: value
        });
      } else {
        dispatch({
          type: "update-state",
          value: value,
          blurValue: !state.blurValue && value
        });
      }
    }

    prevState.current = state.value;
    prevValue.current = value;
  }, [value, state]);

  var handlechange = _react["default"].useCallback(function (v, e) {
    var k = e.target.name;
    dispatch(_defineProperty({
      type: "update-value"
    }, k, v));
    onChange(_objectSpread(_objectSpread({}, value), {}, _defineProperty({}, k, v)));
  }, [value, onChange]);

  var handleBlur = _react["default"].useCallback(function (e) {
    if (state.blurValue) {
      dispatch({
        type: "update-state",
        value: state.blurValue,
        blurValue: null
      });
    }
  }, [state]);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n      grid grid-cols-3\n      ".concat(small ? "gap-x-1" : large ? "gap-x-4" : "gap-x-2", "\n    ")
  }, /*#__PURE__*/_react["default"].createElement(TextInput, {
    type: "number",
    id: "r-".concat(id),
    name: "r",
    small: small,
    large: large,
    min: 0,
    max: 255,
    ref: rInput,
    onChange: handlechange,
    value: state.value.r,
    onBlur: handleBlur,
    showLabels: showLabels,
    label: "Red"
  }), /*#__PURE__*/_react["default"].createElement(TextInput, {
    type: "number",
    id: "g-".concat(id),
    name: "g",
    small: small,
    large: large,
    min: 0,
    max: 255,
    ref: gInput,
    onChange: handlechange,
    value: state.value.g,
    onBlur: handleBlur,
    showLabels: showLabels,
    label: "Green"
  }), /*#__PURE__*/_react["default"].createElement(TextInput, {
    type: "number",
    id: "b-".concat(id),
    name: "b",
    small: small,
    large: large,
    min: 0,
    max: 255,
    ref: bInput,
    onChange: handlechange,
    value: state.value.b,
    onBlur: handleBlur,
    showLabels: showLabels,
    label: "Blue"
  }));
};